export default () => ({
    "entityMap": {
        "0": {
            "type": "image",
            "mutability": "IMMUTABLE",
            "data": {
                "src": "https://i.imgur.com/Szzsdoh.png",
                "width": 100
            }
        },
        "1": {
            "type": "LINK",
            "mutability": "MUTABLE",
            "data": {
                "url": "https://www.jamesriverorthodontics.com"
            }
        },
        "2": {
            "type": "image",
            "mutability": "IMMUTABLE",
            "data": {
                "src": "https://i.imgur.com/RUIKOnh.png",
                "width": 100
            }
        }
    },
    "blocks": [
        {
            "key": "fofie",
            "text": " ",
            "type": "atomic",
            "depth": 0,
            "inlineStyleRanges": [],
            "entityRanges": [
                {
                    "offset": 0,
                    "length": 1,
                    "key": 0
                }
            ],
            "data": {}
        },
        {
            "key": "4k0iv",
            "text": "Put body text here",
            "type": "unstyled",
            "depth": 0,
            "inlineStyleRanges": [],
            "entityRanges": [],
            "data": {}
        },
        {
            "key": "lt2o",
            "text": "Sample link",
            "type": "unstyled",
            "depth": 0,
            "inlineStyleRanges": [
                {
                    "offset": 0,
                    "length": 11,
                    "style": "BOLD"
                },
                {
                    "offset": 0,
                    "length": 11,
                    "style": "UNDERLINE"
                }
            ],
            "entityRanges": [
                {
                    "offset": 0,
                    "length": 11,
                    "key": 1
                }
            ],
            "data": {}
        },
        {
            "key": "1vh0j",
            "text": " ",
            "type": "atomic",
            "depth": 0,
            "inlineStyleRanges": [],
            "entityRanges": [
                {
                    "offset": 0,
                    "length": 1,
                    "key": 2
                }
            ],
            "data": {}
        },
        {
            "key": "aok6a",
            "text": "",
            "type": "unstyled",
            "depth": 0,
            "inlineStyleRanges": [],
            "entityRanges": [],
            "data": {}
        }
    ]
})



// WEBPACK FOOTER //
// ./src/components/sitewide/RichTextEditor/message-templates/basic-jro.js